export const ADD_ERRORS = 'ADD_ERRORS'
export const REMOVE_ERRORS = 'REMOVE_ERRORS'
export const RESET_ERRORS = 'RESET_ERRORS'
export const RESET_ERRORS_UUID = 'RESET_ERRORS_UUID'
export const RESET_VALIDATION_ERRORS = 'RESET_VALIDATION_ERRORS'
export const SET_ERRORS_UUID = 'SET_ERRORS_UUID'
